
import bgImage from '../../../../asset/images/australia.png';
export function HeroSection() {
  return (
    <section className="relative min-h-screen bg-cover bg-center bg-no-repeat" 
             style={{
               backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${bgImage})`
             }}>
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative z-10 container mx-auto px-6 py-32 lg:py-40">
        <div className="max-w-4xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
           All About Australia
          </h1>
          <div className="prose prose-lg text-white max-w-none">
            <p className="text-lg leading-relaxed mb-6">
              Australia is a land full of iconic attractions, but beyond the bustling cities and world-famous landmarks lie hidden gems that offer a more intimate and authentic experience. Among its many wonders, ten niche destinations stand out for their beauty, wilderness, and unique character.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Far off the New South Wales coast, Lord Howe Island remains one of the world’s most exclusive escapes. With visitor numbers strictly limited, this World Heritage-listed paradise enchants travelers with its crystal lagoons, lush forests, and volcanic peaks like Mount Gower, where the views are as dramatic as the hike itself.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              In the south, Kangaroo Island is often called “Australia’s Galápagos” for its abundant wildlife. Here, kangaroos, sea lions, and koalas live freely among rugged cliffs and wild beaches, while Flinders Chase National Park showcases the surreal shapes of the Remarkable Rocks and Admiral’s Arch.
            </p>
             <button className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  Explore SIghtseeing
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center ml-2"></i>
             </button>
          </div>
        </div>
      </div>
    </section>
  );
}
